var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(!_vm.push)?_c('a',{class:`text-supa-blurple underline ${_vm.className}`,attrs:{"href":_vm.url,"target":_vm.target}},[_vm._t("default")],2):_vm._e(),_vm._v(" "),(_vm.push)?_c('span',{class:`text-supa-blurple underline ${_vm.className}`,on:{"click":_vm.handleLinkClick}},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }